import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export async function approveRequest(
  salesOrg: string,
  requestNum: number,
  queueStatus?:string
): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
      requestNum,
      queueStatus,
    },
    url: `${BASE_URL}/api/request/approve`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.error(err));
}

export async function saveRequest(
  salesOrg: string,
  payload: any
): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
      lang: "EN",
    },
    data: payload,
    url: `${BASE_URL}/api/request/save`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.error(err));
}

export async function createRequest(
  salesOrg: string,
  customerNum: string
): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      customerNum,
      optimizationType: "",
      optimizationPackMethod: "",
    },
    url: `${BASE_URL}/api/request/new`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.error(err));
}

export async function rejectRequest(
  salesOrg: string,
  requestNum: number
): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
      requestNum,
    },
    url: `${BASE_URL}/api/request/reject`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.error(err));
}
export async function reopenRequest(
  salesOrg: string,
  requestNum: number
): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
      requestNum,
    },
    url: `${BASE_URL}/api/request/reopen`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.error(err));
}
export async function resubmitRequest(
  salesOrg: string,
  requestNum: number
): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
      requestNum,
    },
    url: `${BASE_URL}/api/request/resubmit`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.error(err));
}
